import React from "react";
import { useTranslation } from "react-i18next";

interface SummaryData {
  total_subtotal_sales: number;
  total_tips: number;
  total_tax: number;
  total_paid_orders: number;
  total_refunded_orders: number;
  total_service_fee_charge: number;
  total_rewards: number;
  total_price: number;
  total_refunded_amount: number;
}

interface Props {
  summaryData: SummaryData;
  loading: boolean;
}

const SelectedDateSummary: React.FC<Props> = ({ summaryData, loading }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-4 mt-4 rounded-lg bg-white p-4 shadow">
      <h2 className="mb-4 text-xl font-bold">
        {t("back.management.report.selectedDate")}
      </h2>
      {loading ? (
        <div className="flex h-32 items-center justify-center">
          <div className="spinner" />
        </div>
      ) : (
        <div className="mt-4 grid grid-cols-2 gap-3">
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.subtotal")}
            </p>
            <p className="text-lg font-bold">
              ${summaryData.total_subtotal_sales.toFixed(2)}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.reward")}
            </p>
            <p className="text-lg font-bold">
              -${summaryData.total_rewards.toFixed(2)}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.tip")}
            </p>
            <p className="text-lg font-bold">
              ${summaryData.total_tips.toFixed(2)}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.tax")}
            </p>
            <p className="text-lg font-bold">
              ${summaryData.total_tax.toFixed(2)}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.paidOrder")}
            </p>
            <p className="text-lg font-bold">{summaryData.total_paid_orders}</p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.refundedAmount")}
            </p>
            <p className="text-lg font-bold">
              -$
              {summaryData?.total_refunded_amount
                ? parseFloat(summaryData.total_refunded_amount.toFixed(2))
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.serviceFee")}
            </p>
            <p className="text-lg font-bold">
              $
              {summaryData?.total_service_fee_charge
                ? parseFloat(summaryData.total_service_fee_charge.toFixed(2))
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.total")}
            </p>
            <p className="text-lg font-bold">
              $
              {summaryData?.total_price
                ? parseFloat(summaryData.total_price.toFixed(2))
                : "0.00"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectedDateSummary;
